// ContactForm.js
import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './ContactForm.css'; // Import the CSS file

const ContactForm = () => {
  const [formData, setFormData] = useState({
    from_name: '',
    email: '',
    message: '',
  });

  const [isEmailSent, setIsEmailSent] = useState(false); // State to track email sent status

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const userId = 'T9RvDOO3NHWwRyVcr';
    const serviceId = 'service_80kykrs';
    const templateId = 'template_et9feao';

    emailjs.send(serviceId, templateId, formData, userId)
      .then((response) => {
        console.log('Email sent successfully:', response);
        setIsEmailSent(true); // Set the state to indicate that the email was sent
        setFormData({ from_name: '', email: '', message: '' }); // Reset the form data
      })
      .catch((error) => {
        console.error('Error sending email:', error);
      });
  };

  return (
    <div className="container">
      <h2>Contact Me</h2>
      <form onSubmit={handleSubmit} className="form">
        <label className="label">
          Name:
          <input
            type="text"
            name="from_name"
            value={formData.from_name}
            onChange={handleChange}
            required
            className="input"
          />
        </label>
        <label className="label">
          Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="input"
          />
        </label>
        <label className="label">
          Message:
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            className="textarea"
          />
        </label>
        <button type="submit" className="button">
          Submit
        </button>
        {isEmailSent && <div className="tooltip">Email Sent!</div>}
      </form>
    </div>
  );
};

export default ContactForm;
